/**
 * ecommate / Wischstar — PDP-only scripts (loaded on product templates only).
 */

(function () {
  function findJudgeMeTarget() {
    return (
      document.getElementById('judgeme_product_reviews') ||
      document.querySelector('.jdgm-rev-widg, .jdgm-review-widget, [id*="judgeme"]')
    );
  }

  function scrollToJudgeMe(event) {
    const link = event.target.closest('a.em-product-rating-link');
    if (!link) return;

    const target = findJudgeMeTarget();
    if (!target) return;

    event.preventDefault();
    const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  document.addEventListener('click', scrollToJudgeMe);
})();

/**
 * Wish Stars: Appstle injects .loyalty-acquire-points-badge as a sibling of the mount.
 * Keep spacing tight; strip badge chrome via CSS. Optional: collapse empty mount only.
 */
(function () {
  function tidy() {
    var text = document.querySelector('.em-rewards__item--points .em-rewards__text');
    if (!text) return;

    var mount = text.querySelector('#appstle-loyalty-acquire-points-block');
    var badge = text.querySelector('.loyalty-acquire-points-badge, .acquire-points-badge');

    if (mount && !String(mount.textContent || '').trim()) {
      mount.setAttribute('hidden', '');
    }

    if (badge) {
      badge.removeAttribute('style');
      badge.querySelectorAll('[style]').forEach(function (el) {
        el.removeAttribute('style');
      });
    }
  }

  function bind() {
    var text = document.querySelector('.em-rewards__item--points .em-rewards__text');
    if (!text) return;

    tidy();
    if (text.dataset.emRewardsBound === '1') return;
    text.dataset.emRewardsBound = '1';

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(tidy, 40);
    });
    observer.observe(text, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  }

  function init() {
    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 500);
  setTimeout(init, 1500);
})();

/**
 * PDP: force qty selector to the same pixel height as the ATC button.
 * Flex/grid stretch is unreliable on <quantity-input>; inline styles win.
 */
(function () {
  var HEIGHT = '3.75rem';

  function apply(el, h) {
    if (!el) return;
    el.style.setProperty('height', h, 'important');
    el.style.setProperty('min-height', h, 'important');
    el.style.setProperty('max-height', h, 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  }

  function sync(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('.em-buy-h');
    if (nodes.length) {
      nodes.forEach(function (el) {
        apply(el, HEIGHT);
      });
      return;
    }

    scope.querySelectorAll('.product__info .buy-buttons, .product__info .product-form__buttons').forEach(function (row) {
      var btn = row.querySelector('.product-form__submit');
      var qty = row.querySelector('quantity-input.quantity, .quantity');
      if (!btn) return;

      var h = btn.getBoundingClientRect().height;
      var px = h > 1 ? Math.round(h * 100) / 100 + 'px' : HEIGHT;

      apply(btn, px);
      if (qty) apply(qty, px);
    });
  }

  function init() {
    sync();
    requestAnimationFrame(function () {
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', init);
  window.addEventListener('resize', function () {
    sync();
  });

  setTimeout(init, 250);
  setTimeout(init, 1000);
})();

(function () {
  /* Lift ZipChat + Trusted Shops above sticky ATC on mobile PDP,
     only while the sticky bar is visible. Desktop uses a centered card. */
  if (!document.body.classList.contains('template-product')) return;

  var BODY_CLASS = 'em-sticky-atc-visible';
  var OFFSET_VAR = '--em-sticky-float-offset';
  var MOBILE_MQ = '(max-width: 767px)';
  var SELECTORS = [
    '#zipchat-shadow-host',
    '#widget-chat-button',
    '[id*="trustbadge"]',
    '[id*="Trustbadge"]',
    '[id*="trustbadge-container"]',
    '[id*="minimized-trustbadge"]',
    '[id*="maximized-trustbadge"]',
  ].join(',');
  var DEFAULT_OFFSET = 108;
  var GAP_PX = 16;
  var fromPassed = false;
  var toReached = false;
  var formEl = null;
  var mediaQuery = window.matchMedia(MOBILE_MQ);
  var started = false;

  function stickyForm() {
    return document.querySelector('product-sticky-form');
  }

  function isMobile() {
    return mediaQuery.matches;
  }

  function measureOffset(form) {
    if (!form) return DEFAULT_OFFSET;
    var card = form.querySelector('.product-sticky-form__card') || form.firstElementChild;
    var h = card ? Math.ceil(card.getBoundingClientRect().height) : 0;
    if (!h) h = Math.ceil(form.getBoundingClientRect().height);
    return (h > 40 ? h : DEFAULT_OFFSET) + GAP_PX;
  }

  function clearLift() {
    document.body.classList.remove(BODY_CLASS);
    document.documentElement.style.setProperty(OFFSET_VAR, '0px');
    document.querySelectorAll(SELECTORS + ', .em-float-lift').forEach(function (el) {
      if (!(el instanceof HTMLElement)) return;
      el.classList.remove('em-float-lift');
      el.style.removeProperty('bottom');
    });
  }

  function applyLift(offsetPx) {
    document.documentElement.style.setProperty(OFFSET_VAR, offsetPx + 'px');
    document.querySelectorAll(SELECTORS).forEach(function (el) {
      if (!(el instanceof HTMLElement)) return;
      el.classList.add('em-float-lift');
      el.style.setProperty('bottom', offsetPx + 'px', 'important');
    });
  }

  function setVisible(visible) {
    if (!isMobile()) {
      clearLift();
      return;
    }
    if (!visible) {
      clearLift();
      return;
    }
    var offset = measureOffset(formEl || stickyForm());
    document.body.classList.add(BODY_CLASS);
    applyLift(offset);
  }

  function syncFromIntersection() {
    setVisible(fromPassed && !toReached);
  }

  function start() {
    if (started) return;
    formEl = stickyForm();
    if (!formEl) return;
    started = true;

    var formId = formEl.getAttribute('form');
    var scopeFrom =
      document.querySelector('.quick-order-list') ||
      (formId ? document.getElementById(formId) : null) ||
      document.querySelector('form[action*="/cart/add"]');
    var scopeTo = document.querySelector('.footer-group') || document.querySelector('footer');

    if (scopeFrom && scopeTo && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === scopeFrom) {
            fromPassed = entry.boundingClientRect.bottom < 0;
          }
          if (entry.target === scopeTo) {
            toReached = entry.isIntersecting;
          }
        });
        syncFromIntersection();
      });
      io.observe(scopeFrom);
      io.observe(scopeTo);
    }

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (document.body.classList.contains(BODY_CLASS)) {
          applyLift(measureOffset(formEl));
        }
      }).observe(formEl);
    }

    window.addEventListener(
      'resize',
      function () {
        if (document.body.classList.contains(BODY_CLASS)) {
          applyLift(measureOffset(formEl || stickyForm()));
        }
      },
      { passive: true }
    );
  }

  function applyDesktopCenter(el) {
    if (!(el instanceof HTMLElement)) return;
    if (!isMobile()) {
      el.style.setProperty('left', '50%', 'important');
      el.style.setProperty('right', 'auto', 'important');
      el.style.setProperty('inset-inline-start', '50%', 'important');
      el.style.setProperty('inset-inline-end', 'auto', 'important');
      el.style.setProperty('inset-block-end', '1.25rem', 'important');
      el.style.setProperty('width', 'max-content', 'important');
      el.style.setProperty('max-width', 'min(40rem, calc(100vw - 10rem))', 'important');
      el.style.setProperty('margin-inline', '0', 'important');
      el.style.setProperty('transform', 'translateX(-50%)', 'important');
    } else {
      el.style.setProperty('left', '0', 'important');
      el.style.setProperty('right', '0', 'important');
      el.style.setProperty('inset-inline-start', '0', 'important');
      el.style.setProperty('inset-inline-end', '0', 'important');
      el.style.setProperty('inset-block-end', '0', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', 'none', 'important');
      el.style.setProperty('margin-inline', '0', 'important');
      el.style.removeProperty('transform');
    }
  }

  function onViewportChange() {
    var form = stickyForm();
    if (form) applyDesktopCenter(form);

    if (isMobile()) {
      start();
      syncFromIntersection();
    } else {
      clearLift();
      start();
    }
  }

  /* Preserve custom sticky ATC label after Concept ProductStickyForm resets it */
  function patchStickyAtcLabel() {
    if (!window.customElements || !customElements.get) return;
    customElements.whenDefined('product-sticky-form').then(function () {
      var Ctor = customElements.get('product-sticky-form');
      if (!Ctor || !Ctor.prototype || Ctor.prototype.__emAtcPatched) return;
      Ctor.prototype.toggleSubmitButton = function (disable, text) {
        if (!this.submitButton) return;
        var submitButtonText = this.submitButton.querySelector('.btn-text');
        var submitButtonTextChild = this.submitButton.querySelector('.btn-text>span');
        var target = submitButtonTextChild || submitButtonText;
        if (disable) {
          this.submitButton.setAttribute('disabled', '');
          if (text && target) target.textContent = text;
          return;
        }
        this.submitButton.removeAttribute('disabled');
        if (!target) return;
        if (this.submitButton.hasAttribute('data-pre-order')) {
          target.textContent = theme.variantStrings.preOrder;
          return;
        }
        var custom = this.submitButton.getAttribute('data-em-atc-label');
        target.textContent = custom || theme.variantStrings.addToCart;
      };
      Ctor.prototype.__emAtcPatched = true;
    });
  }

  patchStickyAtcLabel();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onViewportChange);
  } else {
    onViewportChange();
  }

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', onViewportChange);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(onViewportChange);
  }
})();
